import { AlertCircle, CheckCircle2 } from "lucide-react";
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScaledThumbnail } from "./ScaledThumbnail";

interface GovernanceComplianceCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function GovernanceComplianceCardThumbnail({
  isHovered = false,
  alwaysVisible = false,
}: GovernanceComplianceCardThumbnailProps) {
  return (
    <ScaledThumbnail isHovered={isHovered} alwaysVisible={alwaysVisible}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium">
            Governance & Compliance
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex items-center justify-between p-2 rounded bg-green-50 border border-green-200">
              <div className="flex items-center gap-2">
                <CheckCircle2 className="h-4 w-4 text-green-600" />
                <span className="text-sm">Audit Trail</span>
              </div>
              <Badge className="bg-green-600 text-[10px]">Complete</Badge>
            </div>
            <div className="flex items-center justify-between p-2 rounded bg-green-50 border border-green-200">
              <div className="flex items-center gap-2">
                <CheckCircle2 className="h-4 w-4 text-green-600" />
                <span className="text-sm">Approvals</span>
              </div>
              <Badge className="bg-green-600 text-[10px]">Up to date</Badge>
            </div>
            <div className="flex items-center justify-between p-2 rounded bg-orange-50 border border-orange-200">
              <div className="flex items-center gap-2">
                <AlertCircle className="h-4 w-4 text-orange-600" />
                <span className="text-sm">Policy Review</span>
              </div>
              <Badge className="bg-orange-600 text-[10px]">Due 15 Jan</Badge>
            </div>
          </div>
        </CardContent>
      </Card>
    </ScaledThumbnail>
  );
}
